var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "q-pa-md row full-width" }, [
    _c(
      "div",
      { staticClass: "col-12 text-right q-mb-md" },
      [
        _c("q-btn", {
          attrs: { label: "Создать" },
          on: { click: _vm.createZone }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("Table", {
          attrs: {
            "table-id": "zonesTable",
            "table-config": _vm.tableConfig,
            "table-data": _vm.zones,
            "percentage-width": ""
          },
          on: {
            "row-click": function(val) {
              return _vm.openZoneEdit(val)
            },
            "delete-row": function(val) {
              return _vm.removeZone(val.id)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }